<template>
<section class="section">
  <div class="container">
    <h2 class="has-text-centered" v-html='$t("profile.aboutSpp.header", { sppName: state.sppName})'> </h2>
    <div class="profile richtext container has-text-centered condensed bold" v-html="sppContent?.AppDescription"></div>
    <template v-if="!hasSppContent && !hasAnyStatusTabSections">
        <p><span class="has-text-centered" v-html='$t("profile.ABStatus." + taxonCategroyName + "withoutContent", { sppName: state?.sppName })'></span></p>
      </template>
    <h2/> <!-- for spacing -->
    <div class="columns is-multiline is-centered is-vcentered" v-if="introPhotoCount < 2">
      <div class="column is-4-tablet" v-if="introPhotoCount > 0">
        <photo-images :paths="photoCollection?.habitat[0]?.path" :class="'rounded-2'"
          :isAboutImage="true"
          v-if="photoCollection?.habitat?.length > 0"/>
        <photo-images :paths="photoCollection?.characteristics[0]?.path" :class="'rounded-2'"
          :isAboutImage="true"
          v-if="photoCollection?.characteristics?.length > 0"/>
      </div>
      <div class="column is-8-tablet" :class="{'is-flex': introPhotoCount === 0 }">
        <div class="column" v-if="sppContent?.AppIdMe?.trim().length > 0">
          <h3>{{ $t("profile.aboutSpp.description.title") }} </h3>
          <div class="profile richtext left-align bold" v-html="$t('profile.aboutSpp.description.description', {sppName: state.sppName})"></div>
          <div class="profile richtext left-align" v-html="sppContent?.AppIdMe"></div>
        </div>
        <div class="column" v-if="sppContent?.AppHabitat?.trim().length > 0">
          <h3>{{ $t("profile.aboutSpp.habitat.title") }} </h3>
          <div class="profile richtext left-align bold" v-html="$t('profile.aboutSpp.habitat.description', {sppName: state.sppName})"></div>
          <div class="profile richtext left-align" v-html="sppContent?.AppHabitat"></div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-centered" v-else> <!-- 2 photos-->
      <div class="columns column is-12">
        <div class="column is-4-tablet">
          <photo-images :paths="photoCollection?.characteristics[0]?.path" :class="'rounded-2'"
            :isAboutImage="true"
            v-if="photoCollection?.characteristics?.length > 0"/>
        </div>
        <div class="column is-8-tablet" v-if="sppContent?.AppIdMe?.trim().length > 0">
          <h3>{{ $t("profile.aboutSpp.description.title") }} </h3>
          <div class="profile richtext left-align bold" v-html="$t('profile.aboutSpp.description.description', {sppName: state.sppName})"></div>
          <div class="profile richtext left-align" v-html="sppContent?.AppIdMe"></div>
        </div>
      </div>
      <div class="columns column is-12">
        <div class="column is-4-tablet">
          <photo-images :paths="photoCollection?.habitat[0]?.path" :class="'rounded-2'"
            :isAboutImage="true"
            v-if="photoCollection?.habitat?.length > 0"/>
        </div>
        <div class="column is-8-tablet" v-if="sppContent?.AppHabitat?.trim().length > 0">
          <h3>{{ $t("profile.aboutSpp.habitat.title") }} </h3>
          <div class="profile richtext left-align bold" v-html="$t('profile.aboutSpp.habitat.description', {sppName: state.sppName})"></div>
          <div class="profile richtext left-align" v-html="sppContent?.AppHabitat"></div>
        </div>
      </div>
    </div>
    <p class="has-text-centered auto extra-padding" v-if="displayFewDetectionText.value"><span class="few-detection has-text-centered c1" v-html='$t("profile.ABStatus." + taxonCategroyName + "withoutContent", { sppName: state?.sppName })'></span></p>
  </div>
</section>
</template>
<script>
import { computed } from 'vue'
import { useApp } from '@/composables/state/profileState';
import PhotoImages from '../../../components/biobrowser/PhotoImages.vue';

export default {
  components: { PhotoImages },
  name: 'about-species-section',
  setup (props) {
    const { state, taxonCategroyName, sppContent, hasSppContent, introPhotoCount, introPhotoPaths, photoCollection, hasAnyStatusTabSections } = useApp();
    /* display few detection text below spp content */
    const displayFewDetectionText = computed(() => {
      return (!hasAnyStatusTabSections.value && hasSppContent);
    });

    return {
      state,
      sppContent,
      photoCollection,
      hasAnyStatusTabSections,
      introPhotoCount,
      introPhotoPaths,
      displayFewDetectionText,
      hasSppContent,
      taxonCategroyName
    }
  }
}
</script>

<style scoped>
.search-bar-container {
    display: flex;
    position: relative;
    width: 100%;
    height: 36px;
    min-height: 36px;
}

.column.horizontal{
  display: flex;
  align-items: start;
  justify-content: space-between;
}

.column.horizontal img.smaller {
  width: 90%;
}
h3 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.richtext ::v-deep(ul) {
  margin-top: 5px!important;
}
.side-by-side h3 {
  text-align: left;
}

.side-by-side .img-col {
  width: 35%;
}
.side-by-side .text-col {
  width: 60%;
}
@media screen and (min-width:768px){
  .column.description::after {
    content: '';
    position: absolute;
    right: 0px;
    top: 0%;
    height: 100%;
    width: 100%;
    border-right: 1px solid #ebebed;
  }
}

  .padding-left.text {
    padding-right: 0.75rem;

  }
  .padding-right.text {
    padding-left: 0.75rem;
  }
  .few-detection {
    padding: 5px;
  }

  @media screen and (min-width:1215px){
    .padding-left.text {
      padding-right: 5rem;
      padding-left: 2rem;
    }
    .padding-right.text {
      padding-left: 5rem;
      padding-right: 2rem;
    }
  }

  @media screen and (min-width:1024px){
    .extra-padding {
      padding-left: 15rem;
      padding-right: 15rem;
    }
  }

  .few-detection.has-text-centered.c1 {
    -webkit-box-decoration-break: clone;
    line-height: 2.3rem;
  }
</style>
